import CONTACT_STORAGE_KEY, { CONTACT_INFLOW_ROUTE } from '@src/modules/constants/contact';
import LINKS from '@src/modules/constants/links';
import Button from '@src/ui/elements/button/Button';

function Error500Form({ isTenant }: { isTenant: boolean }) {
  const contactLink: string = isTenant ? LINKS.CONTACT_DXPN : LINKS.CONTACT_BANK;

  const handleContactClick = () => {
    if (isTenant) {
      return;
    }
    localStorage.setItem(CONTACT_STORAGE_KEY.INFLOW_ROUTE, String(CONTACT_INFLOW_ROUTE.ERROR_PAGE));
  };

  return (
    <div className='text-center'>
      <h1 className='mb-1 text-primary-500'>500 Internal Server Error</h1>
      <p className='mb-7 text-lg font-semibold text-[#222222]'>
        サーバー側でエラーが発生しました。
      </p>
      <p className='mb-8 text-center text-[#222222]'>
        ご不便をおかけしますが、
        <br />
        時間を置いて再度アクセスしてください。
      </p>
      <div className='mx-auto max-w-[400px]'>
        <Button
          href={contactLink}
          onClick={handleContactClick}
          size='m'
          variant='primary'
          outline
          fullWidth
          fullRounded
        >
          サポートに報告
        </Button>
      </div>
    </div>
  );
}

export default Error500Form;
